import axios from "axios";
import {getCookie} from "./cookie";
import {config} from "./config";

// const baseUri = 'https://api.goficial.net/web/';
// const baseUri = 'https://dev-api.goficial.net/web/';
// const baseUri = 'http://localhost:3001/web/';
export const post = (uri, data, conf = {}) => {
    let headers = {
        "x-auth": getCookie("token")
    }

    if (conf.headers) {
        headers = {...headers, ...conf.headers};
    }

    return axios.post(`${config.baseUrl}${uri}`, data, {headers}).then(data => {

        if (data.status !== 200) {
            // eslint-disable-next-line no-throw-literal
            throw false;
        }
        return data.data
    }).catch(e => {
        const {response} = e;
        if(response && response.status === 429) {
            alert("Too Many Requests");
        }
    });;
}

export const put = (uri, data, conf = {}) => {
    let headers = {
        "x-auth": getCookie("token")
    }
    if (conf.headers) {
        headers = conf.headers;
    }
    return axios.put(`${config.baseUrl}${uri}`, data, {...conf, headers}).then(data => {

        if (data.status !== 200) {
            // eslint-disable-next-line no-throw-literal
            throw false;
        }
        return data.data
    }).catch(e => {
        const {response} = e;
        if(response && response.status === 429) {
            alert("Too Many Requests");
        }
    });;
}

export const deletep = (uri, data, conf = {}) => {
    let headers = {
        "x-auth": getCookie("token")
    }
    if (conf.headers) {
        headers = conf.headers;
    }
    return axios.delete(`${config.baseUrl}${uri}`, {data, headers}).then(data => {

        if (data.status !== 200) {
            // eslint-disable-next-line no-throw-literal
            throw false;
        }
        return data.data
    }).catch(e => {
        const {response} = e;
        if(response && response.status === 429) {
            alert("Too Many Requests");
        }
    });;
}

export const get = (uri, data, conf = {}) => {
    let headers = {
        "x-auth": getCookie("token")
    }
    if (conf.headers) {
        headers = conf.headers;
    }
    return axios.get(`${config.baseUrl}${uri}`, {params: data, headers}).then(data => {

        if (data.status !== 200) {
            throw new Error(false);
        }
        return data.data;
    }).catch(e => {
        const {response} = e;
        if(response && response.status === 429) {
            alert("Too Many Requests");
        }
    });
}
